import modal from './modal.store'
import statusBar from './statusbar.store'
import breadcrumb from './breadcrumb.store'
import importFile from './import/'
import people from './people/'
import campaign from './campaign/'
import auth from './auth.store'
import dashboard from './dashboard/'
import organization from './organization'

export default {
  modal,
  statusBar,
  breadcrumb,
  importFile,
  people,
  campaign,
  auth,
  dashboard,
  organization
}
